module.exports = __webpack_public_path__ + "img/mums.2192e1e9.jpg";